var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50033 0.164062C1.04009 0.164062 0.666992 0.537159 0.666992 0.997396C0.666992 1.45763 1.04009 1.83073 1.50033 1.83073H1.50866C1.9689 1.83073 2.34199 1.45763 2.34199 0.997396C2.34199 0.537159 1.9689 0.164062 1.50866 0.164062H1.50033Z",
    fill: "#2D3648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 0.164062C5.20676 0.164062 4.83366 0.537159 4.83366 0.997396C4.83366 1.45763 5.20676 1.83073 5.66699 1.83073H16.5003C16.9606 1.83073 17.3337 1.45763 17.3337 0.997396C17.3337 0.537159 16.9606 0.164062 16.5003 0.164062H5.66699Z",
    fill: "#2D3648"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 5.16406C5.20676 5.16406 4.83366 5.53716 4.83366 5.9974C4.83366 6.45763 5.20676 6.83073 5.66699 6.83073H16.5003C16.9606 6.83073 17.3337 6.45763 17.3337 5.9974C17.3337 5.53716 16.9606 5.16406 16.5003 5.16406H5.66699Z",
    fill: "#2D3648"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83366 10.9974C4.83366 10.5372 5.20676 10.1641 5.66699 10.1641H16.5003C16.9606 10.1641 17.3337 10.5372 17.3337 10.9974C17.3337 11.4576 16.9606 11.8307 16.5003 11.8307H5.66699C5.20676 11.8307 4.83366 11.4576 4.83366 10.9974Z",
    fill: "#2D3648"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 5.9974C0.666992 5.53716 1.04009 5.16406 1.50033 5.16406H1.50866C1.9689 5.16406 2.34199 5.53716 2.34199 5.9974C2.34199 6.45763 1.9689 6.83073 1.50866 6.83073H1.50033C1.04009 6.83073 0.666992 6.45763 0.666992 5.9974Z",
    fill: "#2D3648"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50033 10.1641C1.04009 10.1641 0.666992 10.5372 0.666992 10.9974C0.666992 11.4576 1.04009 11.8307 1.50033 11.8307H1.50866C1.9689 11.8307 2.34199 11.4576 2.34199 10.9974C2.34199 10.5372 1.9689 10.1641 1.50866 10.1641H1.50033Z",
    fill: "#2D3648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateLists);
export default __webpack_public_path__ + "static/media/template-lists.9eb45320e0a61d4ffb169e0989e814d3.svg";
export { ForwardRef as ReactComponent };